import { render } from "./ServersTable.vue?vue&type=template&id=4438aba3&scoped=true"
import script from "./ServersTable.vue?vue&type=script&lang=ts"
export * from "./ServersTable.vue?vue&type=script&lang=ts"

import "./ServersTable.vue?vue&type=style&index=0&id=4438aba3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4438aba3"

export default script